import { useAuth } from "@/store/authStore";
import React from "react";
import Typography from "@/ui/Typography/Typography";
import WebAppContainer from "@/components/WebAppContainer/WebAppContainer";
import { useVersion } from "@/utils/hooks/useVersionCheck";
import cls from "./styles.module.scss";

const TelegramId = ({ color }: { color?: string }) => {
  const { userId } = useAuth();
  const version = useVersion();
  const style = { ...(color ? { color } : {}) };
  if (!userId)
    return (
      <WebAppContainer className={cls.text}>
        <Typography style={style} variant="body3">
          Not authorised, v{version}
        </Typography>
      </WebAppContainer>
    );

  return (
    <WebAppContainer className={cls.text}>
      <Typography style={style} variant="body3">
        ID: {userId}, v{version}
      </Typography>
    </WebAppContainer>
  );
};

export default TelegramId;
